<template>
  <div>
    <h2 class="bb-page-title">Executive</h2>
  </div>
</template>

<script>
export default {
  name: 'Executive'
}
</script>

<style lang="scss" scoped>
  @import "../../sass/_variables";
</style>



// WEBPACK FOOTER //
// src/components/Executive/Executive.vue